import type { Goal, PlanEventCategory } from '@/api/generated/model';

export const GOAL_PLANNING_CATEGORIES = [
  'career',
  'realEstate',
  'lifestyle',
  'borrowing',
  'equity',
  'estate',
  'philanthropy',
  'retirement',
] as const satisfies readonly PlanEventCategory[];

export function goalCategory(goal: Goal): string {
  return goal.category ?? 'lifestyle';
}

export function isGoalActive(goal: Goal): boolean {
  return goal.active !== false;
}

/** Lump-sum goal impact in the goal's due year (career/lifestyle goals). */
export function goalCashImpactForYear(goals: Goal[], year: number): number {
  let impact = 0;
  for (const goal of goals) {
    if (!isGoalActive(goal)) continue;
    const category = goalCategory(goal);
    if (category !== 'career' && category !== 'lifestyle') continue;
    if (!goal.dueDate) continue;
    const dueYear = new Date(goal.dueDate).getFullYear();
    if (dueYear === year) {
      impact += goal.targetAmount - goal.currentAmount;
    }
  }
  return impact;
}
